class SidebarGradient {
  constructor() {
    this.scrollContainer = document.getElementById('sidebar-scroll');
    this.gradient = document.getElementById('sidebar-gradient');
    
    if (!this.scrollContainer || !this.gradient) {
      return;
    }
    
    this.threshold = 100; // pixels from bottom to start hiding
    
    this.init();
  }
  
  init() {
    // Check initial state
    this.updateGradient();
    
    // Listen for scroll events
    this.scrollContainer.addEventListener('scroll', () => this.updateGradient());
    
    // Listen for resize events (content might change overflow state)
    window.addEventListener('resize', () => this.updateGradient());
  }
  
  updateGradient() {
    const { scrollTop, scrollHeight, clientHeight } = this.scrollContainer;
    const hasOverflow = scrollHeight > clientHeight;
    const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
    
    // Hide gradient if no overflow, or if scrolled near bottom
    if (!hasOverflow || distanceFromBottom < this.threshold) {
      this.gradient.style.opacity = '0';
    } else {
      this.gradient.style.opacity = '1';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SidebarGradient();
  });
} else {
  new SidebarGradient();
}
